// src/data/loadPhrases.js
// Lädt die Redewendungen einer Lernsprache aus public/data/<lang>_phrases.csv
// (Semikolon-getrennt, Kopfzeile id;<lang>;de;type, z. B. id;es;de;type).
// Felder wie bei den Sätzen: target = Lernsprache, src = Muttersprache (Deutsch).
// Fehlt die Datei, kommt eine leere Liste zurück.
import { cachedByLang, fetchLangCsvLines, headerIndex } from "./loadLangCsv";

export const loadPhrases = cachedByLang(async (lang) => {
  const lines = await fetchLangCsvLines(lang, "phrases");
  if (!lines) return [];

  const cols = headerIndex(lines[0]);
  if (cols.id === undefined || cols[lang] === undefined || cols.de === undefined) {
    throw new Error(`Ungültige Kopfzeile in ${lang}_phrases.csv – erwartet: id;${lang};de;type`);
  }

  return lines
    .slice(1)
    .map((line) => {
      const parts = line.split(";");
      const id = (parts[cols.id] || "").trim();
      const target = (parts[cols[lang]] || "").trim();
      if (!id || !target) return null;
      return {
        id,
        target,
        src: (parts[cols.de] || "").trim(),
        type: ((cols.type !== undefined && parts[cols.type]) || "phrase").trim(),
      };
    })
    .filter(Boolean);
});
